import "./App.css";
import { useState, useEffect,useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Redirect from "./Pages/Redirect";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

export default function App() {
  //+Redux
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  console.log("Anathema")
  const [Pather, setPather] = useState(false);
  const [Pather2, setPather2] = useState(false);
  // 
  useEffect(() => {
    navigate(`booknow/Spa-Menu`)
    setPather(true)
    // If you want to navigate programmatically, you can use navigate("/somePath");
  }, [Pather]);
  useEffect(() => {
    navigate(`Spa-Menu`)
    setPather(true)
    // If you want to navigate programmatically, you can use navigate("/somePath");
  }, [Pather2]);
  return (
    
      <Routes>
          
      {Pather==false?
     
      <>
      <Route index path={`/`} element={setPather(true)} />
      <Route index path={`booknow`} element={setPather(true)} />
      <Route index path={`booknow/`} element={setPather(true)} />
      <Route index path={`booknow/spa-menu`} element={setPather(true)} />
      <Route index path={`spa-menu`} element={setPather2(true)} />
      </>
      :
      <>
      <Route index path={`booknow/spa-menu`} element={
        
        <iframe
          className="resizable-iframe"
          src="https://book.spaonline.gr/Centralbooknow?pcode=Parocks"
          style={{
            width: '100vw',
            height: '100vh',
            display: 'block'
          }}
        ></iframe>
      
      } />
      <Route index path={`spa-menu`} element={
          
        <iframe
          className="resizable-iframe"
          src="https://book.spaonline.gr/Centralbooknow?pcode=Parocks"
          style={{
            width: '100vw',
            height: '100vh',
            display: 'block'
          }}
        ></iframe>
      
      } />
    </>
    }
    
      </Routes>
    
  );
}
